// Bot detection patterns
const botPatterns = [
  /bot/i,
  /spider/i,
  /crawl/i,
  /slurp/i,
  /mediapartners/i,
  /adsbot/i,
  /feedfetcher/i,
  /google/i,
  /yahoo/i,
  /bing/i,
  /baidu/i,
  /yandex/i,
  /duckduck/i,
  /teoma/i,
  /aol/i,
  /facebook/i,
  /twitter/i,
  /linkedin/i
];

function isBot(): boolean {
  const userAgent = navigator.userAgent;
  return botPatterns.some(pattern => pattern.test(userAgent));
}

function getUserType(): 'user' | 'bot' {
  return isBot() ? 'bot' : 'user';
}

function getSessionId(): string {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
}

// Get API endpoint
function getApiUrl(): string {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8787';
  }
  return 'https://api.remotetime.work';
}

export async function trackEvent(event: string, properties?: Record<string, any>) {
  try {
    const sessionId = getSessionId();
    const userType = getUserType();
    const eventData = {
      event,
      page: window.location.pathname,
      properties: properties || {},
      userType,
      sessionId,
      userAgent: navigator.userAgent,
    };

    // Send to Cloudflare API
    const response = await fetch(`${getApiUrl()}/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData),
    });

    if (!response.ok) {
      throw new Error(`Analytics API error: ${response.status}`);
    }

    console.log('Event tracked to Cloudflare:', event);
  } catch (error) {
    console.error('Analytics error:', error);
    
    // Fallback to localStorage if API fails
    try {
      const events = JSON.parse(localStorage.getItem('analytics_events_backup') || '[]');
      events.push({
        event,
        page: window.location.pathname,
        properties: properties || {},
        userType: getUserType(),
        sessionId: getSessionId(),
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      });
      // Keep only last 50 events
      if (events.length > 50) {
        events.shift();
      }
      localStorage.setItem('analytics_events_backup', JSON.stringify(events));
      console.log('Event saved to localStorage backup:', event);
    } catch (storageError) {
      console.error('Failed to save to localStorage:', storageError);
    }
  }
}

// Helper functions for common events
export function trackPageView(page: string) {
  trackEvent('page_view', { page });
}

export function trackAction(action: string, properties?: Record<string, any>) {
  trackEvent('user_action', { action, ...properties });
}

// Initialize analytics (no-op now, keeping for compatibility)
export function initializeAnalytics() {
  console.log('Analytics ready - using Cloudflare backend');
}
